<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('common_198')"
    icon="res-user"
    :res-name="detailData.name"
    :actions="params.actions"
    :current-tab="params.windowData.currentTab"
    :tabs="detailTabs"
    :loaded="loaded"
    @tab-change="handleTabChange">
    <template v-slot:actions>
      <actions :options="singleActions" :row="detailData" button-type="link" button-size="small" />
    </template>
    <component :is="params.windowData.currentTab" :onManager="onManager" :res-id="data.id" :data="detailData" :getParams="getParams" :workflowColumns="columns" />
  </base-side-page>
</template>

<script>
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import Actions from '@/components/PageList/Actions'
import AlertrecortList from '@Monitor/views/alertrecord/components/List'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'
import MePartakeDetail from './Detail'

export default {
  name: 'MePartakeSidePage',
  components: {
    MePartakeDetail,
    Actions,
    AlertrecortList,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin, SingleActionsMixin],
  data () {
    return {
    }
  },
  computed: {
    detailTabs () {
      const ret = [{ label: this.$t('common_386'), key: 'me-partake-detail' }]
      if (['alert-event', 'alert-ticket'].includes(this.detailData?.variables?.process_definition_key)) {
        ret.push({ label: this.$t('monitor.text_10'), key: 'AlertrecortList' })
      }
      return ret
    },
    getParams () {
      if (this.params.windowData.currentTab === 'AlertrecortList') {
        return {
          res_id: this.detailData?.variables?.resource_id,
          alert_id: this.detailData?.variables?.alert_id,
        }
      }
      return null
    },
  },
}
</script>
